import { Telemetry, convertToLocalTimezone, getNow } from 'model';
import { useCallback } from 'react';
import { installationTZ } from '../api/PostApi';

export type TelemetryData = Pick<Telemetry, 'data' | 'actionTarget' | 'actionType'>;

export type TelemetryReporter = (telemetry: TelemetryData) => void;

const localTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
/**
 * Hook to get a TelmetryReporter, handles setting localDateTime etc.
 * @returns { TelemetryReporter } - Telemetry reporter function
 */
export function useTelemetryReporter(): TelemetryReporter {
	return useCallback((telemetryData: TelemetryData) => {
		// Send the request to create the telemtry, catching any errors
		// not using async/await because we only care about catching errors as this is inteded to be 'fire and forget'
		fetch('/api/telemetry', {
			method: 'POST',
			body: JSON.stringify({
				...telemetryData,
				localDateTime: convertToLocalTimezone(getNow(), localTZ, installationTZ)
			}),
			headers: {
				'Content-Type': 'application/json'
			}
		}).catch(e => {
			// eslint-disable-next-line no-console
			console.error(e);
		});
	}, []);
}
